// Pure-CSS illustration evoking a credit-usage card (label · amount/limit · progress bar).
export function BillingEmptyStateIllustration() {
  return (
    <div className="mb-6 w-2xs rounded-lg border bg-gray-50 p-4 shadow-lg/3">
      <div className="mb-3 h-2.5 w-24 rounded-sm bg-gray-200/80"></div>
      <div className="mb-3 flex items-baseline gap-2">
        <div className="h-5 w-16 rounded-sm bg-gray-300/70"></div>
        <div className="h-2.5 w-10 rounded-sm bg-gray-200/50"></div>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200/60">
        <div className="h-full w-2/5 rounded-full bg-teal-500/50"></div>
      </div>
    </div>
  );
}
